import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentPageLayout from '../components/ContentPageLayout';

const Garantiebedingungen = () => {
  const { t } = useTranslation();

  return (
    <ContentPageLayout>
      {/* Garantiebedingungen Hauptbereich */}
      <section className="py-6 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-2 xl:max-w-[1800px]">
          
          {/* Überschrift */}
          <h1 className="text-lg sm:text-xl font-semibold text-white bg-gray-900 px-6 py-3 rounded-t-lg">
            {t('garantiePage.title')}
          </h1>

          {/* Textbereich */}
          <div className="bg-gray-50 rounded-b-xl border border-gray-200 border-t-0 p-6 md:p-8">
                
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-10">
              {t('garantiePage.intro')}
            </p>

            {/* Abschnitt 1 */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                {t('garantiePage.section1Title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {t('garantiePage.section1Text')}
              </p>
            </div>

            {/* Abschnitt 2 */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                {t('garantiePage.section2Title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {t('garantiePage.section2Text')}
              </p>
            </div>

            {/* Abschnitt 3 */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                {t('garantiePage.section3Title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {t('garantiePage.section3Text')}
              </p>
            </div>

            {/* Abschnitt 4 */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                {t('garantiePage.section4Title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {t('garantiePage.section4Text')}
              </p>
            </div>

            {/* Abschnitt 5 */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                {t('garantiePage.section5Title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {t('garantiePage.section5Text')}
              </p>
            </div>

            {/* Abschnitt 6 */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                {t('garantiePage.section6Title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {t('garantiePage.section6Text')}
              </p>
            </div>

            {/* Abschnitt 7 */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                {t('garantiePage.section7Title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {t('garantiePage.section7Text')}
              </p>
            </div>

            {/* Abschnitt 8 */}
            <div>
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                {t('garantiePage.section8Title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {t('garantiePage.section8Text')}
              </p>
            </div>

          </div>
        </div>
      </section>
    </ContentPageLayout>
  );
};

export default Garantiebedingungen;
